import React, { Component } from "react";
import { Route, Switch } from 'react-router-dom';

import Home from '../views/Home/Home';
import User from '../views/user/User';
import MasterUser from '../views/Master/User/User';
import MasterKategori from '../views/Master/Kategori/Kategori';
import MasterKlasifikasi from '../views/Master/Klasifikasi/Klasifikasi';
import MasterSubKlasifikasi from '../views/Master/SubKlasifikasi/SubKlasifikasi';
import MasterPelanggan from '../views/Master/Pelanggan/Pelanggan';
import TelegramUser from '../views/Master/TelegramUser/TelegramUser';
import KlasifikasiPekerjaan from '../views/Klasifikasi/KlasifikasiPekerjaan';
import DataTraffic from '../views/DataTraffic/DataTraffic';
import Monitoring from '../views/MRTG/Monitoring/Monitoring';
import MonitoringPerTanggal from '../views/MRTG/MonitoringPerTanggal/MonitoringPerTanggal';
import Laporan from '../views/MRTG/Laporan/Laporan';
import LaporanPerTanggal from '../views/MRTG/LaporanPerTanggal/LaporanPerTanggal';
import Map from '../views/MRTG/Map/Map';
import DownloadLaporan from '../views/Download/Laporan/Laporan';
import UnathorizedPage from '../views/Other/UnathorizedPage';


export class Routes extends Component  {
    constructor(props) {
        super(props);

        this.options = {
            
        }
        this.state = {
            user: this.props.user
        }
     
    }

    checkAuthorized(role){
        let return_value = false;
        let user_role = this.props.user.role;
        for (let index = 0; index < role.length; index++) {
            if (role[index] === user_role){
                return_value = true;
            }
        }

        return return_value;
    }

    render(){
        return(
            <Switch>
                <Route exact path ='/' component={(this.checkAuthorized(['root','admin', 'user']) === true) ? Home : UnathorizedPage} />
                <Route exact path ='/dashboard/dashboard_1' component={(this.checkAuthorized(['root','admin', 'user']) === true) ? Home : UnathorizedPage} />
                <Route exact path ='/dashboard/dashboard_2' component={(this.checkAuthorized(['user']) === true) ? User : UnathorizedPage} />
                <Route exact path ='/master/user' component={(this.checkAuthorized(['root', 'admin']) === true) ? MasterUser : UnathorizedPage} />
                <Route exact path ='/master/kategori' component={(this.checkAuthorized(['root', 'admin']) === true) ? MasterKategori : UnathorizedPage} />
                <Route exact path ='/master/kategori/:id/klasifikasi' component={(this.checkAuthorized(['root', 'admin']) === true) ? MasterKlasifikasi : UnathorizedPage} />
                <Route exact path ='/master/kategori/:kategori_id/klasifikasi/:id/sub' component={(this.checkAuthorized(['root', 'admin']) === true) ? MasterSubKlasifikasi : UnathorizedPage} />
                <Route exact path ='/master/pelanggan' component={(this.checkAuthorized(['root', 'admin']) === true) ? MasterPelanggan : UnathorizedPage} />
                <Route exact path ='/master/telegram' component={(this.checkAuthorized(['root', 'admin']) === true) ? TelegramUser : UnathorizedPage} />
                <Route exact path ='/pekerjaan' component={(this.checkAuthorized(['root', 'admin']) === true) ? KlasifikasiPekerjaan : UnathorizedPage} />
                <Route exact path ='/traffic' component={(this.checkAuthorized(['root', 'admin']) === true) ? DataTraffic : UnathorizedPage} />
                <Route exact path ='/monitoring' component={(this.checkAuthorized(['root', 'admin', 'user']) === true) ? Monitoring : UnathorizedPage} />
                <Route exact path ='/monitoring/:kategori_id' component={(this.checkAuthorized(['root', 'admin', 'user']) === true) ? Monitoring : UnathorizedPage} />
                <Route exact path ='/monitoring/:kategori_id/:klasifikasi_id' component={(this.checkAuthorized(['root', 'admin', 'user']) === true) ? Monitoring : UnathorizedPage} />
                <Route exact path ='/monitoring_pertanggal' component={(this.checkAuthorized(['root', 'admin', 'user']) === true) ? MonitoringPerTanggal : UnathorizedPage} />
                <Route exact path ='/laporan' component={(this.checkAuthorized(['root', 'admin']) === true) ? Laporan : UnathorizedPage} />
                <Route exact path ='/laporan_pertanggal' component={(this.checkAuthorized(['root', 'admin']) === true) ? LaporanPerTanggal : UnathorizedPage} />
                <Route exact path ='/map' component={(this.checkAuthorized(['root', 'admin']) === true) ? Map : UnathorizedPage} />
                <Route exact path ='/download' component={(this.checkAuthorized(['root', 'admin', 'user']) === true) ? DownloadLaporan : UnathorizedPage} />
            </Switch>
        );
    }

}
